/* 场馆信息相关接口 */
import path from '@/api/index'
import {
  axios,
  axiosFile
} from '@/utils/request'
import parsePageParams from '@/utils/page'
// import {jsonp} from 'vue-jsonp'
import storage from "store";
import {ACCESS_TOKEN} from '@/store/mutation-types'

// 分页
export function queryList(data) {
  return axios({
    url: path.mobile + '/order',
    method: 'POST',
    data: data,
    params: parsePageParams(data)
  })
}

// 获取详情
export function get(id) {
  return axios({
    url: path.mobile + '/order/id/' + id,
    method: 'GET'
  })
}

// 根据核销码获取详情
export function getByExchangeCode(code) {
  return axios({
    url: path.mobile + '/order/getByExchangeCode/' + code,
    method: 'GET'
  })
}

// 取消
export function cancel(data) {
  return axios({
    url: path.mobile + '/order/cancel',
    data: data,
    method: 'post'
  })
}

// 支付
export function pay(data) {
  return axios({
    url: path.mobile + '/order/pay',
    data: data,
    method: 'post'
  })
}

// 缴费平台支付
export function platformWxPay(data) {
  const url = `/api/mobile/pay?id=${data.id}&Authorization=${storage.get(ACCESS_TOKEN)}`
  window.location = url
  // return axios({
  //   url: path.mobile + '/pay',
  //   data: data,
  //   method: 'post'
  // })
  //  return jsonp(url,{
  //   callbackQuery:'callbackParam', //一定要加这两个参数
  //   callbackName:'jsonpCallback', //一定要加这两个参数,要不然会报错 导致代码阻塞
  //    header: {
  //      "Authorization": storage.get(ACCESS_TOKEN) // 豆瓣一定不能是json
  //    }
  // })
}

// 评价
export function evaluation(data) {
  return axios({
    url: path.mobile + '/order/evaluation',
    data: data,
    method: 'post'
  })
}

// 更新服务
export function updateService(data) {
  return axios({
    url: path.mobile + '/order/updateService',
    data: data,
    method: 'post'
  })
}

// 凭证下载
export function downInventory (id) {
  return axiosFile({
    url: path.mobile + '/order/downInventory/' + id,
    method: 'GET'
  })
}

// 核销
export function writeOff (data) {
  return axios({
    url: path.back + '/orderInfo/writeOff',
    method: 'PUT',
    data: data
  })
}
